module.exports = function() {
  return new Worker(__webpack_public_path__ + "49088eda8320b76d72ba.worker.js");
};